import React from 'react';
import moment from 'moment-timezone';
import { useCurrentMembership } from '@identity/hooks';

const TIME_VARIANT_MAP = {
  short_format: 'MM/DD/YYYY',
  long_format: 'MM/DD/YYYY [at] h:mma zz',
  mid_format: 'MM/DD/YYYY, h:mmA',
  mid_format_with_tz: 'MM/DD/YYYY, h:mmA z',
  verbose_shorter: 'ddd, MMM D, YYYY',
  verbose_format: 'ddd, MMMM Do, YYYY',
};

export const TimeWithTimeZone = ({
  date,
  variant = 'short_format',
  timeZone = 'UTC',
}: {
  date: string | moment.Moment;
  variant?: keyof typeof TIME_VARIANT_MAP;
  timeZone?: string;
}) => {
  const format = TIME_VARIANT_MAP[variant];
  const currentMembership = useCurrentMembership({ hideError: true });

  if (!date) {
    return null;
  }

  const membershipTimeZone = currentMembership?.worksUser?.timeZone;
  const finalTimeZone = membershipTimeZone || timeZone;
  const finalDate = moment(date).tz(finalTimeZone).format(format);

  return <>{finalDate}</>;
};
